export const masterKeyHostMapping = [
	/* Disabled Mapping for mercedes */
	// {
	// 	hosts: ["https://mercedes.staging.ridevu.com", "https://mercedes.uat.ridevu.com", "https://mercedes.ridevu.com"],
	// 	masterKey: "75-5-ab2ef",
	// },
	{
		hosts: ["https://staging.ridevudemo.com", "https://uat.ridevudemo.com", "https://ridevudemo.com"],
		masterKey: "40-5-13f7c",
	},
];
